module.exports = __webpack_public_path__ + "static/media/jumbled-words-rptr-fish.493ca83e.svg";